import { render, staticRenderFns } from "./deliverBoxesData.vue?vue&type=template&id=8afa0436&scoped=true&"
import script from "./deliverBoxesData.vue?vue&type=script&lang=js&"
export * from "./deliverBoxesData.vue?vue&type=script&lang=js&"
import style0 from "./deliverBoxesData.vue?vue&type=style&index=0&id=8afa0436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afa0436",
  null
  
)

component.options.__file = "deliverBoxesData.vue"
export default component.exports